import * as XLSX from 'xlsx';
import { ExcelLayouts } from '../settings/ExcelLayouts';

export const parseCalibrationExcel = async (file, formatKey = 'MASTER_METER_V1') => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });

                // Asumimos primera hoja
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];

                const layout = ExcelLayouts[formatKey];
                if (!layout) {
                    throw new Error(`Formato no configurado: ${formatKey}`);
                }

                const result = parseGeneric(worksheet, layout);
                resolve(result);

            } catch (error) {
                console.error("Error parsing Excel:", error);
                reject(error);
            }
        };

        reader.onerror = (error) => reject(error);
        reader.readAsArrayBuffer(file);
    });
};

// Utils
const getCellValue = (ws, cellAddress) => {
    const cell = ws[cellAddress];
    return cell ? cell.v : null;
};

const excelDateToJSDate = (serial) => {
    if (!serial) return null;
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);
    return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate());
};

// --- GENERIC PARSER ---

const parseGeneric = (ws, layout) => {
    const head = {};

    // Parse HEAD based on layout keys
    Object.keys(layout.head).forEach(key => {
        const cellAddr = layout.head[key];
        const val = getCellValue(ws, cellAddr);

        if (key === 'Fecha' && typeof val === 'number') {
            head[key] = excelDateToJSDate(val);
        } else {
            head[key] = val;
        }
    });

    // Parse DETAILS
    const details = [];
    const { startRow, validationRow, columns, rowsMap } = layout.details;

    columns.forEach(col => {
        // Validation (optional)
        if (validationRow) {
            const valCell = getCellValue(ws, `${col.id}${validationRow}`);
            if (valCell === null || valCell === undefined || valCell === '') return;
        }

        // Build data object
        const rowData = {
            carga: col.loadIdx
        };

        let hasData = false;

        rowsMap.forEach((field, idx) => {
            const currentRow = startRow + idx;
            const val = getCellValue(ws, `${col.id}${currentRow}`);

            if (val !== null && val !== undefined) {
                rowData[field] = val;
                hasData = true; // Mark as valid row if at least one value exists? Or first value? 
                // Legacy logic usually checks first value.
            } else {
                rowData[field] = 0; // Default to 0?
            }
        });

        // Basic validation: if ErrorVolumenBruto (usually first item) is present
        // Or if we have data.
        // Legacy logic: if (v1 != null)
        if (hasData && rowData[rowsMap[0]] !== undefined) {
            details.push(rowData);
        }
    });

    return { head, details };
};
